<template>
	<div>
		<BaseCollapse title="付款資訊">
			<TotalStatementDetailSectionPayment :default-value="submitData" />
		</BaseCollapse>
		<BaseCollapse title="使用人備註">
			<div class="p-3">
				<div class="inline-between mb-2">
					<div style="font-weight: 500; margin-bottom: 10px">使用人資訊</div>
					<el-button type="text" style="padding-top: 0" size="mini" @click="openNoteEdit">
						<BaseIcon name="edit" class="text-primary mr-2" />編輯備註
					</el-button>
				</div>
				<ul class="userInfo">
					<li class="mb-2">{{ defaultValue.fullName }} {{ defaultValue.gender | genderFilter }}</li>
					<li class="mb-2">{{ `${defaultValue.phoneCode} ${defaultValue.phoneNumber}` }}</li>
					<li class="mb-2" style="display: block">使用人備註：{{ defaultValue.note || '目前尚無備註' }}</li>
				</ul>
				<div v-if="!isEmptyByOrderExtrafields" class="byOrderExtrafieldsInfo">
					<ul v-for="(byOrderExtrafield, byOrderExtrafieldIndex) in defaultValue.byOrderExtrafields"
						:key="`byOrderExtrafieldIndex-${byOrderExtrafieldIndex}`">
						<li class="title">{{ byOrderExtrafield.title }}</li>
						<li v-if="byOrderExtrafield.value" class="value">{{ byOrderExtrafield.value }}</li>
					</ul>
				</div>
			</div>
		</BaseCollapse>
	</div>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'
import formatDate from '@utils/format-date'
import { genderFilter, orderPaymentMethodMap, paymentStatusMapFilter, bookingStatusFilter } from '@utils/filter-value-to-text'
import cloneDeep from 'lodash/cloneDeep'

const initData = () => {
	return {
		params: [],
	}
}

export default {
	name: 'NoteAndDetailSectionPayment',
	data() {
		return {};
	},
	filters: {
    formatDate,
    paymentStatusMapFilter,
    bookingStatusFilter,
    genderFilter,
  },
	props: {
		defaultValue: {
			type: Object,
			default: () => initData(),
		},
	},
	watch: {
		defaultValue: {
			handler() {
				this.submitData = cloneDeep(this.defaultValue)
			},
			immediate: true,
			deep: true,
		},
	},
	computed: {
		isEmptyByOrderExtrafields() {
			return this.defaultValue.byOrderExtrafields instanceof Array
		},
	},
	created() { },
	mounted() { },
	methods: {
		openNoteEdit(){
			this.$emit('openNoteEdit')
		},
	},
	components: {
		BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
		TotalStatementDetailSectionPayment: () => lazyLoadComponent(import('./TotalStatementDetailSectionPayment')),
		TotalStatementDetailDropdown: () => lazyLoadComponent(import('./TotalStatementDetailDropdown')),
		BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
	},
};
</script>

<style lang="scss" module></style>
